import push from './app/push';

export {push as push}


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 1
// module chunks = 0